import { render, staticRenderFns } from "./prodottiCorrelati.vue?vue&type=template&id=86b29f88&"
import script from "./prodottiCorrelati.vue.ts?vue&type=script&lang=ts&"
export * from "./prodottiCorrelati.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports